
export default function WhyChooseUs() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/dae4fde8334ca2feb9c77059628f8524.jpg"
          alt="Healthy crops in field"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/95 via-stone-900/85 to-stone-900/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block text-emerald-400 font-bold text-xs tracking-widest uppercase mb-4">
              The Difference
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Built for the Way Farmers Work
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8 font-light">
              We understand that farming isn&apos;t about technology for technology&apos;s sake. It&apos;s about
              getting the job done right, at the right time, with less damage to your crops and soil.
            </p>

            <div className="space-y-5">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: 'Zero Wheel Traffic',
                  desc: 'No compaction, no broken stalks, no stand loss — your crop stays intact.',
                },
                {
                  icon: 'ri-time-line',
                  title: 'Timing That Matters',
                  desc: 'We apply when ground equipment can’t enter — wet fields, tall crops, narrow windows.',
                },
                {
                  icon: 'ri-hand-heart-line',
                  title: 'Partnership Approach',
                  desc: 'We work with you to understand your operation, goals, and constraints. No pressure.',
                },
                {
                  icon: 'ri-bar-chart-box-line',
                  title: 'Data-Driven Decisions',
                  desc: 'Aerial surveys and field assessments that help you make better calls, season after season.',
                },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/20 rounded-lg shrink-0 mt-0.5">
                    <i className={`${item.icon} text-lg text-emerald-400`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{item.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center border border-white/10">
                <div className="text-3xl font-bold text-emerald-400 mb-1">12,000+</div>
                <div className="text-sm text-gray-300">Acres Served</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center border border-white/10">
                <div className="text-3xl font-bold text-emerald-400 mb-1">8+</div>
                <div className="text-sm text-gray-300">Industry Sectors</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center border border-white/10">
                <div className="text-3xl font-bold text-emerald-400 mb-1">100%</div>
                <div className="text-sm text-gray-300">On-Time Rate</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center border border-white/10">
                <div className="text-3xl font-bold text-emerald-400 mb-1">$38/ac</div>
                <div className="text-sm text-gray-300">Avg. Net Profit Gain</div>
              </div>
            </div>

            <div className="mt-4 bg-emerald-700/30 backdrop-blur-sm rounded-lg p-6 border border-emerald-500/20">
              <p className="text-white font-bold text-lg mb-1">
                &quot;This is not a drone company.&quot;
              </p>
              <p className="text-emerald-200 text-sm font-light">
                It&apos;s a farming partner focused on yield, protection, and return per acre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
